const state = {
  logs: [
    {
      id: 1,
      adminId: 1,
      adminName: '管理员',
      action: '登录系统',
      module: '认证',
      target: '系统',
      details: 'IP: 192.168.1.100, 浏览器: Chrome 120',
      ip: '192.168.1.100',
      status: 'success',
      createdAt: '2026-03-05T12:00:00'
    },
    {
      id: 2,
      adminId: 1,
      adminName: '管理员',
      action: '创建用户',
      module: '用户管理',
      target: '用户ID: 1001',
      details: '创建了新用户: 张三',
      ip: '192.168.1.100',
      status: 'success',
      createdAt: '2026-03-05T11:30:00'
    },
    {
      id: 3,
      adminId: 2,
      adminName: '运营人员',
      action: '审核债务',
      module: '债务管理',
      target: '债务ID: 5001',
      details: '审核通过债务金额: ¥10000',
      ip: '192.168.1.101',
      status: 'success',
      createdAt: '2026-03-05T11:00:00'
    },
    {
      id: 4,
      adminId: 3,
      adminName: '财务人员',
      action: '处理提现',
      module: '积分管理',
      target: '提现ID: 3001',
      details: '处理提现金额: ¥5000',
      ip: '192.168.1.102',
      status: 'success',
      createdAt: '2026-03-05T10:30:00'
    },
    {
      id: 5,
      adminId: 1,
      adminName: '管理员',
      action: '修改角色权限',
      module: '权限管理',
      target: '角色ID: 2',
      details: '为运营人员角色添加了任务编辑权限',
      ip: '192.168.1.100',
      status: 'success',
      createdAt: '2026-03-05T10:00:00'
    },
    {
      id: 6,
      adminId: 4,
      adminName: '客服人员',
      action: '查看用户详情',
      module: '用户管理',
      target: '用户ID: 1002',
      details: '查看了用户李四的详细信息',
      ip: '192.168.1.103',
      status: 'success',
      createdAt: '2026-03-05T09:30:00'
    },
    {
      id: 7,
      adminId: 2,
      adminName: '运营人员',
      action: '导出用户数据',
      module: '用户管理',
      target: '用户列表',
      details: '导出了100条用户数据',
      ip: '192.168.1.101',
      status: 'success',
      createdAt: '2026-03-05T09:00:00'
    },
    {
      id: 8,
      adminId: 1,
      adminName: '管理员',
      action: '系统配置修改',
      module: '系统管理',
      target: '系统配置',
      details: '修改了积分兑换率配置',
      ip: '192.168.1.100',
      status: 'success',
      createdAt: '2026-03-05T08:30:00'
    },
    {
      id: 9,
      adminId: 3,
      adminName: '财务人员',
      action: '批量审核',
      module: '债务管理',
      target: '债务列表',
      details: '批量审核了10笔债务',
      ip: '192.168.1.102',
      status: 'success',
      createdAt: '2026-03-05T08:00:00'
    },
    {
      id: 10,
      adminId: 1,
      adminName: '管理员',
      action: '登录失败',
      module: '认证',
      target: '系统',
      details: '密码错误，尝试登录',
      ip: '192.168.1.100',
      status: 'failed',
      createdAt: '2026-03-05T07:30:00'
    }
  ],
  filters: {
    module: '',
    action: '',
    adminName: '',
    status: '',
    dateRange: []
  }
}

const mutations = {
  SET_LOGS: (state, logs) => {
    state.logs = logs
  },
  ADD_LOG: (state, log) => {
    state.logs.unshift(log)
  },
  SET_FILTERS: (state, filters) => {
    state.filters = { ...state.filters, ...filters }
  },
  CLEAR_FILTERS: (state) => {
    state.filters = {
      module: '',
      action: '',
      adminName: '',
      status: '',
      dateRange: []
    }
  }
}

const actions = {
  // 获取操作日志
  fetchLogs({ commit, state }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        // 模拟过滤
        let filteredLogs = [...state.logs]
        
        if (state.filters.module) {
          filteredLogs = filteredLogs.filter(log => log.module === state.filters.module)
        }
        
        if (state.filters.action) {
          filteredLogs = filteredLogs.filter(log => log.action.includes(state.filters.action))
        }
        
        if (state.filters.adminName) {
          filteredLogs = filteredLogs.filter(log => log.adminName.includes(state.filters.adminName))
        }
        
        if (state.filters.status) {
          filteredLogs = filteredLogs.filter(log => log.status === state.filters.status)
        }
        
        if (state.filters.dateRange && state.filters.dateRange.length === 2) {
          const [start, end] = state.filters.dateRange
          filteredLogs = filteredLogs.filter(log => {
            const logDate = new Date(log.createdAt)
            const startDate = new Date(start)
            const endDate = new Date(end)
            return logDate >= startDate && logDate <= endDate
          })
        }
        
        resolve(filteredLogs)
      }, 300)
    })
  },
  
  // 添加操作日志
  addLog({ commit }, logData) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newLog = {
          id: Date.now(),
          ...logData,
          createdAt: new Date().toISOString()
        }
        commit('ADD_LOG', newLog)
        resolve(newLog)
      }, 100)
    })
  },
  
  // 设置过滤器
  setFilters({ commit }, filters) {
    commit('SET_FILTERS', filters)
  },
  
  // 清除过滤器
  clearFilters({ commit }) {
    commit('CLEAR_FILTERS')
  }
}

const getters = {
  logs: state => state.logs,
  filters: state => state.filters,
  getLogById: state => id => state.logs.find(log => log.id === id),
  getLogsByModule: state => module => state.logs.filter(log => log.module === module),
  getLogsByAdminId: state => adminId => state.logs.filter(log => log.adminId === adminId),
  getFilteredLogs: state => {
    let filteredLogs = [...state.logs]
    
    if (state.filters.module) {
      filteredLogs = filteredLogs.filter(log => log.module === state.filters.module)
    }
    
    if (state.filters.action) {
      filteredLogs = filteredLogs.filter(log => log.action.includes(state.filters.action))
    }
    
    if (state.filters.adminName) {
      filteredLogs = filteredLogs.filter(log => log.adminName.includes(state.filters.adminName))
    }
    
    if (state.filters.status) {
      filteredLogs = filteredLogs.filter(log => log.status === state.filters.status)
    }
    
    if (state.filters.dateRange && state.filters.dateRange.length === 2) {
      const [start, end] = state.filters.dateRange
      filteredLogs = filteredLogs.filter(log => {
        const logDate = new Date(log.createdAt)
        const startDate = new Date(start)
        const endDate = new Date(end)
        return logDate >= startDate && logDate <= endDate
      })
    }
    
    return filteredLogs
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
